import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as FormDesignGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general";
import { Route as FormDesignPreviewPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/"
)({
    component: FormDesignDetailPage,
    staticData: {
        permissions: [PermissionEnum.ToolDesignFormGeneral, PermissionEnum.ToolDesignFormEditor],
        showInSideMenu: false,
        label: "pages.tool.design.form.detail.title",
        redirects: [FormDesignGeneralPage, FormDesignPreviewPage],
        defaultRedirect: FormDesignGeneralPage,
    },
});

function FormDesignDetailPage() {
    return <RedirectPage />;
}
